import { Controller } from "remult";

@Controller("opportunity-skill-methods")
export class OpportunitySkillMethods {}
